import { useMutation, gql } from '@apollo/react-hooks';
import { useCallback } from 'react';
import type { FetchCognitoUsersMutation } from '#/graphql/types';
import { fetchCognitoUsers as fcu } from '#/graphql/mutations'
import { get } from 'lodash';

const q = gql(fcu);

const useFetchCognitoUsers = () => {
    const [mutation, result] = useMutation<FetchCognitoUsersMutation>(q);
    const fetchCognitoUsers = useCallback(
        async () => {
            const response = await mutation({});

            return get(response, 'data', undefined);
        },
        [mutation],
    );

    return { fetchCognitoUsers, result };
};
// Used in the modules ModuleDataGrid file
export default useFetchCognitoUsers;
